import { motion } from 'framer-motion';
import { Disc3, ExternalLink } from 'lucide-react';

const LinkCard = ({ title, subtitle, url, platform }) => {
  return (
    <motion.a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="border border-[#0A0A0A] bg-[#F2F2F2] overflow-hidden block"
      whileHover={{ y: -2 }}
      transition={{ duration: 0.2 }}
      data-testid={`link-card-${platform.toLowerCase()}`}
    >
      <div className="h-[180px] flex items-center bg-[#E5E5E5] hover:bg-[#D1FF00] transition-colors group">
        <div className="flex items-center gap-6 px-6 w-full">
          <div className="w-16 h-16 border-2 border-[#0A0A0A] flex items-center justify-center flex-shrink-0 group-hover:bg-[#0A0A0A] transition-colors">
            <ExternalLink className="w-6 h-6 text-[#0A0A0A] group-hover:text-[#D1FF00] transition-colors" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-mono text-xs uppercase tracking-widest text-[#A3A3A3] group-hover:text-[#0A0A0A]/60 transition-colors">{platform}</p>
            <h3 className="font-bold text-xl mt-1 truncate">{title}</h3>
            {subtitle && <p className="font-mono text-sm text-[#A3A3A3] group-hover:text-[#0A0A0A]/60 mt-1 transition-colors">{subtitle}</p>}
          </div>
          <Disc3 className="w-10 h-10 text-[#A3A3A3] group-hover:text-[#0A0A0A]/40 transition-colors flex-shrink-0 hidden sm:block" />
        </div>
      </div>
    </motion.a>
  );
};

export const MusicPlayer = () => {
  return (
    <section data-testid="music-section" className="section-border p-8 lg:p-12">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <h2 className="text-3xl md:text-4xl font-bold uppercase tracking-tight mb-8 flex items-center gap-4">
          <span className="w-8 h-[2px] bg-[#D1FF00]" />
          Listen
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {/* Mixcloud - Direct Player */}
          <div className="border border-[#0A0A0A] bg-[#F2F2F2] overflow-hidden" data-testid="mixcloud-player">
            <div className="p-4 bg-[#E5E5E5] border-b border-[#0A0A0A]">
              <p className="font-mono text-xs uppercase tracking-widest text-[#A3A3A3]">Mixcloud</p>
              <h3 className="font-bold text-xl mt-1">New Beats Selections</h3>
              <p className="font-mono text-sm text-[#A3A3A3] mt-1">DJ Mix — Tap to play</p>
            </div>
            <div className="h-[120px]">
              <iframe
                title="New Beats Selections"
                width="100%"
                height="120"
                src="https://www.mixcloud.com/widget/iframe/?hide_cover=1&feed=%2Fsimonflee%2Fnew-beats-selections-vol-1%2F"
                frameBorder="0"
                allow="autoplay"
                style={{ border: 'none' }}
              />
            </div>
          </div>
          
          {/* SoundCloud Link */}
          <LinkCard
            platform="SoundCloud"
            title="Unreleased Tracks"
            subtitle="Original Productions — Open Playlist"
            url="https://soundcloud.com/simon-flee/sets/unreleased-tracks/s-5k2VCMENdVq"
          />
        </div>
      </motion.div>
    </section>
  );
};
